/**
 * 치환 한 함수. **ICU MessageFormat 을 도입하지 않는다** — 이 규모에서 필요한 것은
 * `{name}` 치환과 복수형 둘뿐이다 (`docs/22` §4.3, 결정 D4).
 */
const PLACEHOLDER = /\{(\w+)\}/g;
/** 없는 이름은 치환하지 않고 **그대로 둔다** — 빈칸보다 `{n}` 이 눈에 띈다. */
function substitute(template, params) {
    if (!params)
        return template;
    return template.replace(PLACEHOLDER, (whole, name) => {
        const value = params[name];
        return value === undefined ? whole : String(value);
    });
}
/**
 * 사전 하나로 `t()` 를 만든다.
 *
 * **복수형은 `_one`/`_other` 둘뿐이다.** `n === 1` 이면 `_one`, 그 밖은 `_other`.
 * 한국어는 두 값을 같은 문장으로 채운다 — 한국어에 수 일치가 없기 때문이고, 그래도
 * 두 키를 두는 이유는 **영어 사전이 그 구분을 필요로 하기 때문**이다.
 *
 * 사전에 없는 키는 **키 자체를 돌려준다.** 타입이 이미 막고 있으므로 여기 오는 것은
 * 타입을 우회한 경우뿐이고, 그때는 빈칸보다 키가 보이는 편이 고치기 쉽다.
 */
export function createTranslator(messages) {
    const table = messages;
    return (key, params) => {
        const count = params?.['n'];
        if (typeof count === 'number') {
            const plural = table[`${key}${count === 1 ? '_one' : '_other'}`];
            if (plural !== undefined)
                return substitute(plural, params);
        }
        const exact = table[key];
        return exact === undefined ? key : substitute(exact, params);
    };
}
//# sourceMappingURL=translate.js.map